const re_ID = /^[a-zA-Z][12]\d{8}$/
const re_resident = /^[A-Z][ABCD89]\d{8}$/
const re_mail = /^([a-zA-Z0-9]+(?:[._-]+|[a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/;
const re_Tel = /^(09)[0-9]{8}$/;
const re_zh = /^([\u4e00-\u9fa5]|\w)+$/;
const re_num = /\d+/;
const re_addr = /^([\u4e00-\u9fa5]|\w|[-,.，])+$/;

const CheckData = {
    id(value) {
        if(re_ID.test(value)){
            return 'taiwan';
        }
        if(re_resident.test(value)){
            return 'resident';
        }
        return false;
    },
    mobile(value) {
        if(!re_Tel.test(value)){
            return false;
        }
        if(value.length != 10){
            return false;
        }
        return true;
    },
    email(value) {
        return re_mail.test(value);
    },
    address(value) {
        if(!re_addr.test(value)){
            return false;
        }
        if(!value.includes("號")){
            return false;
        }
        return true;
    },
    name(value){
        if(!re_zh.test(value)){
            return false;
        }
        if(re_num.test(value)){
            return false;
        }
        return true;
    },
    convertToHalfWidth(value){
        return value
            .replace(/[\uFF01-\uFF5E]/g, (char) =>
                String.fromCharCode(char.charCodeAt(0) - 0xfee0)
            )
            .replace(/\u3000/g, " "); // Convert full-width spaces to half-width spaces
    },
}
export default CheckData;
